<template>
  <div class="techskills">
    <div class="row">
      <div class="col-md-12">
        <div class="section-title">
          <h3>Tech Skills</h3>
          <p> * Smile is not icon for that tech, working hard to draw it * </p>
        </div>
      </div>
    </div>
    <!--.row-->
    <div class="Skills row">
      <div class="col-md-12">
        <TechSkillsItems />
    </div>
  </div>
  <!--.row -->
</div>
</template>
<script>
import TechSkillsItems from './tech-skills-items'
export default {
  name: 'TechSkills',
  components: {
    TechSkillsItems
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
